// extracted by mini-css-extract-plugin
export var bottomCenter = "CardLogo-module--bottomCenter--8e6bf";
export var bottomLeft = "CardLogo-module--bottomLeft--26408";
export var bottomRight = "CardLogo-module--bottomRight--51503";
export var logo = "CardLogo-module--logo--7e983";
export var logoContainer = "CardLogo-module--logoContainer--eff6f";
export var topLeft = "CardLogo-module--topLeft--8ac7d";
export var topRight = "CardLogo-module--topRight--7e4ab";